import React, { useState } from 'react';
import { PhoneIcon, CalendarIcon, MailIcon, Video, ExternalLink, Sparkles } from 'lucide-react';
import { GOOGLE_CALENDAR_DIRECT_URL, GOOGLE_CALENDAR_EMBED_URL } from './utils/bookingConstants';
import BookingModal from './components/BookingModal';

const ContactUs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen page-container py-8 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto space-y-8">
        {/* Contact Information Card */}
        <div className="glass-card glass-card-large">
          <h2 className="glass-card-title text-xl sm:text-2xl md:text-3xl mb-3 text-center">
            Get In Touch
          </h2>
          <p className="glass-card-text text-center max-w-2xl mx-auto mb-6">
            We're excited to connect with you and explore how our quantitative strategies and algorithmic solutions can help you achieve your financial objectives.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            {/* WhatsApp Chat Button */}
            <a
              href="https://wa.me/+2347026976893"
              target="_blank"
              rel="noopener noreferrer"
              className="glass-btn glass-btn-success flex items-center justify-center py-3.5 px-4"
            >
              <PhoneIcon className="mr-2 text-emerald-400" size={20} />
              Chat on WhatsApp
            </a>

            {/* Book Appointment Modal Trigger Button */}
            <button
              onClick={() => setIsModalOpen(true)}
              className="glass-btn glass-btn-primary flex items-center justify-center py-3.5 px-4"
            >
              <Video className="mr-2 text-blue-400" size={20} />
              Book Google Meet Call
            </button>
          </div>

          {/* Email Support Alert */}
          <div className="glass-alert glass-alert-info">
            <div className="flex items-center justify-center">
              <MailIcon className="mr-2 text-blue-400" size={20} />
              <div className="text-center">
                <div className="glass-card-subtitle mb-1">Email Support</div>
                <a
                  href="mailto:hello@ksquants.com"
                  className="glass-card-text hover:text-white transition-colors font-medium"
                >
                  hello@ksquants.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Embedded Google Calendar Scheduling Section */}
        <div className="glass-card glass-card-large" id="schedule-consultation">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4 pb-3 border-b border-white/10">
            <div>
              <h3 className="text-lg sm:text-xl font-bold text-white flex items-center gap-2">
                <CalendarIcon className="text-blue-400" size={22} />
                Schedule a Consultation
                <span className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-0.5 rounded-full bg-emerald-500/20 text-emerald-300 border border-emerald-500/30">
                  <Video size={12} /> Google Meet
                </span>
              </h3>
              <p className="text-xs sm:text-sm text-slate-300 mt-1">
                Select your preferred date & time below for a live one-on-one session.
              </p>
            </div>

            <a
              href={GOOGLE_CALENDAR_DIRECT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-blue-400 hover:text-blue-300 hover:underline inline-flex items-center gap-1 font-medium whitespace-nowrap"
            >
              Open in Google Calendar <ExternalLink size={12} />
            </a>
          </div>

          {/* Embedded Calendar Frame */}
          <div className="rounded-xl overflow-hidden border border-white/10 shadow-inner bg-slate-950 min-h-[580px] relative">
            <iframe
              src={GOOGLE_CALENDAR_EMBED_URL}
              title="Google Calendar Appointment Scheduling"
              width="100%"
              height="620"
              frameBorder="0"
              className="w-full h-full min-h-[580px] bg-white"
              allow="camera; microphone; fullscreen; display-capture"
            />
          </div>

          <div className="mt-3 flex items-center justify-between text-xs text-slate-400">
            <span className="flex items-center gap-1.5 text-slate-300">
              <Sparkles size={13} className="text-blue-400" />
              Confirmation with Google Meet link will be emailed to you automatically.
            </span>
          </div>
        </div>
      </div>

      {/* Reusable Booking Modal */}
      <BookingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Schedule a Consultation"
      />
    </div>
  );
};

export default ContactUs;
